<app-system-message></app-system-message>
@if (isLoading) {
<div class="container-fluid">
  <!-- Loading Element -->
  <nav [ngClass]="theme.getThemeClass()" class="loading-gif">
  <!-- Container with box styles and fade-in-out animation -->
    <div class="box fade-in-out" >
      <!-- Font Awesome spinner icon with custom styles -->
      <div class="fa-3x mb-2">
          <i class="fa-solid fa-spinner fa-spin-pulse fa-2xl color"></i>
      </div>
      <!-- Logo container with dynamic theme class and navigation link -->
      <div>
          <a [ngClass]="theme.getThemeClass()"
          class=" hide-too-small-screen navbar-brand px-1" href="javascript:void(0);" data-bs-toggle="dropdown">
              <!-- Logo image with custom styles -->
              <img class="logo" src="../assets/muirwood-studio.png">
          </a>
      </div>
  </div>
  </nav>
</div>
}
@if (!isLoading) {
<div [ngClass]="theme.getThemeClass()">
  <!-- Section for header and filter -->
  <header class="page-header">
    <!-- For future development -->
    <h2>{{"workOrderList" | translate}}</h2>
  </header>
    <nav
    id="search-component"
    class="nav-sort-filter"
  >
    <input
      #searchBox
      type="search"
      id="search-box"
      [(ngModel)]="userFilter"
      (input)="
        this.search()
      "
      class="form-control rounded searchInput"
      placeholder="{{ 'userlistSearchInputPlaceHolder' | translate }}"
      aria-label="Search"
      aria-describedby="search-addon"
    />
    <select
      class="form-control ng-select sort-by-select"
      [(ngModel)]="filterBy"
      [ngClass]="{ 'has-value': filterBy }"
      (change)="onSortChange('filter', $event)"
    >
      <option value="">{{ 'filterBy' | translate }}</option>
      @for (option of filterOptions; track option.value) {
        <option [value]="option.value">{{ option.label | translate }}</option>
      }
    </select>
    <select
      class="form-control ng-select sort-by-select"
      [(ngModel)]="sortBy"
      [ngClass]="{ 'has-value': sortBy }"
      (change)="onSortChange('select', $event)"
    >
      <option value="">{{ 'sortBy' | translate }}</option>
      @for (option of sortOptions; track option.value) {
        <option [value]="option.value">{{ option.label | translate }}</option>
      }
    </select>
    <div class="card-title mt-0 status">
      <label class="switch">
          <input type="checkbox" [ngModel]="this.ascDesc" (change)="onSortChange('switch', $event)">
          <span class="slider round">
            <span class="toggle-switch-label-off">{{ "asc" | translate }}</span>
            <span class="toggle-switch-label-on">{{ "desc" | translate }}</span>
          </span>
      </label>
  </div>
  </nav>
  <section class="createBtns d-flex justify-content-center mb-2">
    <button [ngClass]="theme.getThemeClass()" class="btn btn-dropdown"  routerLink="/work-order-create">
      {{  "createWorkOrder" | translate }}
    </button>
  </section>
  <div class="grid-container">
    <section [ngClass]="theme.getThemeClass()" class="gridster" [ngStyle]="getColumnStyle()" style="height: 100vh!important;">
      @for (item of this.workOrderModalService.workOrderArray; track item.work_order_id) {
      <article class="gridster-item">
        <!-- Your tile content goes here -->
          <nav [ngClass]="theme.getThemeClass()" class="dashboard-tile">
            <header class="dashboard-tile-header">
              <h6 class="dashboard-tile-title">{{ item.work_order_id }}</h6>
            </header>

            <div class="tiles-container">
              <div class="work-order-owner-infos">
                <div>
                  <i class="fa-solid fa-circle-question"></i><label class="item-label">{{ item.work_order_type | translate }}</label>
                </div>
                <div>
                  <i class="fa-solid fa-user"></i><label class="item-label">{{ item.legal_name }}</label>
                </div>
                <div>
                  <i class="fa fa-trash"></i><label class="item-label">{{ item.bin_id }}</label>
                </div>
                @if (item.thing_name) {
                  <i class="fa-solid fa-microchip device-icon"></i><label class="item-label">{{ item.thing_name }}</label>
                }
              </div>
              <hr>
              <div class="work-order-infos">
                <div>
                  <a (click)="changeWorkOrderStatus(item)"><i class="fa-solid fa-hourglass-start"></i><label class="item-label label-clickable">{{ item.status | translate }}</label></a>
                </div>
                <div>
                  <a [ngClass]="theme.getThemeClass()" (click)="changeWorkOrderDeadlineDate(item)"><i class="fa-regular fa-calendar"></i><label class="item-label label-clickable">{{ formatDate(item.work_order_deadline) }}</label></a>
                </div>
                <div class="work-order-description">
                  <a [ngClass]="theme.getThemeClass()" (click)="changeWorkOrderDescription(item)" class="comments-div"><i class="fa-solid fa-circle-question"></i><label class="item-label label-clickable">{{ item.description | translate }}</label></a>
                </div>
                <hr>
                <label>{{ 'comments' | translate }}</label>
                <div class="work-order-comments">
                  <a (click)="changeWorkOrderComments(item)"><i class="fa-solid fa-comment"></i><label class="item-label label-clickable">{{ item.comment | translate }}</label></a>
                </div>
              </div>
            </div>
            
          </nav>
        </article>
    }
  </section>
  </div>

  @if (this.workOrderModalService.showModal) {
  <app-work-order-dashboard-modal class="modal-container" [ngClass]="theme.getThemeClass()"></app-work-order-dashboard-modal>
  }
</div>
}
<div style="height: 400px !important; width: 10px !important;"></div>
